const DEV = process.env.NODE_ENV === 'development'
import initPhotoSwipeLightbox from '../modules/photoswipeLightbox'
import MicroModal from 'micromodal' // es6 module

export default {
  init() {
    if (window.UsElectionData) {
      const resultsTolltip = document.getElementById('results-tooltip')
      const tooltipContainer = document.querySelector('.us-election-container')
      const currentLanguage = document.documentElement.lang
      let haveResults = false
      MicroModal.init({ disableFocus: true })
      // duplicate the json variable UsEelectionData and create a new object with all its data
      window.Temp_UsElectionData = JSON.parse(
        JSON.stringify(window.UsElectionData)
      )
      calculateUsData()
      // create a new object with all its data
      const usModal = document.getElementById('modal-US')
      document.querySelectorAll('.single-state').forEach((element) => {
        let stateData = window.Temp_UsElectionData.find(
          (state) => state.Code === element.getAttribute('data-state')
        )
        if (stateData.Res === 'true') {
          haveResults = true
          usModal.classList.add('have-results')
          element.addEventListener('mouseover', (e) => {
            element.style.cursor = 'default'
            resultsTolltip.classList.remove('hidden')
            resultsTolltip.querySelector('.state-name').textContent =
              stateData.State
            resultsTolltip.querySelector('.state-votes').textContent =
              stateData.Votes
            resultsTolltip.querySelector('.res-label').textContent =
              stateData.Label
            resultsTolltip.querySelector('.result-msg').innerHTML =
              stateData.ResData

            if (stateData.Ranking === 'solid-D') {
              resultsTolltip
                .querySelector('.final-name')
                .classList.remove('bgcolor-solid-R')
              resultsTolltip
                .querySelector('.final-name')
                .classList.add('bgcolor-solid-D')
              resultsTolltip.querySelector('.final-name').textContent = 'Harris'
            } else if (stateData.Ranking === 'solid-R') {
              resultsTolltip
                .querySelector('.final-name')
                .classList.remove('bgcolor-solid-D')
              resultsTolltip
                .querySelector('.final-name')
                .classList.add('bgcolor-solid-R')
              resultsTolltip.querySelector('.final-name').textContent = 'Trump'
            }

            const updateTooltipPosition = (event) => {
              const containerRect = tooltipContainer.getBoundingClientRect()
              if (
                event.clientX + resultsTolltip.offsetWidth >
                window.innerWidth
              ) {
                if (event.clientX - resultsTolltip.offsetWidth < 10) {
                  resultsTolltip.style.left = `${
                    event.clientX - resultsTolltip.offsetWidth / 2
                  }px`
                } else {
                  resultsTolltip.style.left = `${
                    event.clientX - resultsTolltip.offsetWidth
                  }px`
                }
              } else {
                resultsTolltip.style.left = `${
                  event.clientX - containerRect.left
                }px`
              }
              resultsTolltip.style.top = `${
                event.clientY - containerRect.top
              }px`
            }

            updateTooltipPosition(e)

            element.addEventListener('mousemove', updateTooltipPosition)

            element.addEventListener(
              'mouseout',
              () => {
                resultsTolltip.classList.add('hidden')
                element.removeEventListener('mousemove', updateTooltipPosition)
              },
              { once: true }
            )
          })
        }
      })

      document.querySelectorAll('.single-state').forEach((element) => {
        element.addEventListener('click', (e) => {
          let stateData = window.Temp_UsElectionData.find(
            (state) => state.Code === element.getAttribute('data-state')
          )
          if (stateData.Res === 'true') {
            return
          }
          window.currentUsState = stateData.Code
          usModal.querySelector('.state-votes').textContent = stateData.Votes
          usModal.querySelector('.state-polls').textContent = stateData.Polls
          if (currentLanguage.includes('es')) {
            usModal.querySelector('.state-name').textContent =
              stateData.State_ES
          } else if (currentLanguage.includes('it')) {
            usModal.querySelector('.state-name').textContent =
              stateData.State_IT
          } else {
            usModal.querySelector('.state-name').textContent = stateData.State
          }

          //usModal.querySelector('.state-rank').textContent = stateData.Ranking
          switch (stateData.Ranking) {
            case 'solid-R':
              usModal.querySelector('.state-rank').textContent =
                document.querySelector('.string-rep').textContent
              break
            case 'user-sel-D':
            case 'solid-D':
              usModal.querySelector('.state-rank').textContent =
                document.querySelector('.string-dem').textContent
              break
            case 'lean-D':
              usModal.querySelector('.state-rank').textContent =
                document.querySelector('.string-l-dem').textContent
              break
            case 'lean-R':
              usModal.querySelector('.state-rank').textContent =
                document.querySelector('.string-l-rep').textContent
              break
            case 'swing':
              usModal.querySelector('.state-rank').textContent =
                document.querySelector('.string-toss').textContent
              break
          }

          usModal.querySelectorAll('.btn-us-elections').forEach((element) => {
            element.classList.remove('active')
          })
          if (
            stateData.Ranking === 'user-sel-R' ||
            stateData.Ranking === 'solid-R'
          ) {
            usModal
              .querySelector('.btn-us-elections[data-party="R"]')
              .classList.add('active')
          } else if (
            stateData.Ranking === 'user-sel-D' ||
            stateData.Ranking === 'solid-D'
          ) {
            usModal
              .querySelector('.btn-us-elections[data-party="D"]')
              .classList.add('active')
          } else if (stateData.Ranking === 'lean-D') {
            usModal
              .querySelector('.btn-us-elections[data-party="lD"]')
              .classList.add('active')
          } else if (stateData.Ranking === 'lean-R') {
            usModal
              .querySelector('.btn-us-elections[data-party="lR"]')
              .classList.add('active')
          } else if (stateData.Ranking === 'swing') {
            usModal
              .querySelector('.btn-us-elections[data-party="S"]')
              .classList.add('active')
          }

          usModal
            .querySelector('.state-rank')
            .classList.remove(
              'solid-D',
              'lean-D',
              'user-sel-D',
              'solid-R',
              'lean-R',
              'user-sel-R'
            )
          usModal
            .querySelector('.state-rank')
            .classList.add(element.getAttribute('data-rank'))
          usModal.querySelector('.state-rank').classList.add(stateData.Ranking)
          MicroModal.show('modal-US')
        })
      })

      usModal.querySelectorAll('.btn-us-elections').forEach((element) => {
        element.addEventListener('click', (e) => {
          if (element.classList.contains('active')) {
            //console.log('click active')
            element.classList.remove('active')
            window.Temp_UsElectionData.find(
              (state) => state.Code === window.currentUsState
            ).Ranking = 'swing'
            calculateUsData()
            setTimeout(() => {
              MicroModal.close('modal-US')
            }, 200)
            return
          } else {
            //console.log('click non active')
            document
              .querySelectorAll('.btn-us-elections')
              .forEach((element) => {
                element.classList.remove('active')
              })
            element.classList.add('active')

            const selectedCandidate = element.getAttribute('data-party')
            if (selectedCandidate === 'R') {
              window.Temp_UsElectionData.find(
                (state) => state.Code === window.currentUsState
              ).Ranking = 'solid-R'
              //console.log('selected R')
            } else if (selectedCandidate === 'lR') {
              window.Temp_UsElectionData.find(
                (state) => state.Code === window.currentUsState
              ).Ranking = 'lean-R'
              console.log('selected lR')
            } else if (selectedCandidate === 'D') {
              window.Temp_UsElectionData.find(
                (state) => state.Code === window.currentUsState
              ).Ranking = 'solid-D'
              console.log('selected D')
            } else if (selectedCandidate === 'lD') {
              window.Temp_UsElectionData.find(
                (state) => state.Code === window.currentUsState
              ).Ranking = 'lean-D'
              console.log('selected lD')
            } else if (selectedCandidate === 'S') {
              window.Temp_UsElectionData.find(
                (state) => state.Code === window.currentUsState
              ).Ranking = 'swing'
            }

            calculateUsData()
            setTimeout(() => {
              MicroModal.close('modal-US')
            }, 200)
          }
        })
      })

      document
        .querySelector('.us-election-bkg')
        .addEventListener('click', (e) => {
          MicroModal.close('modal-US')
        })

      document
        .getElementById('reset-us-data')
        .addEventListener('click', (e) => {
          resetUsData()
          MicroModal.close('modal-US')
        })
    }

    initPhotoSwipeLightbox('.post-template')
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //console.log('finalize common');
  },
}

function resetUsData() {
  window.Temp_UsElectionData = {}
  window.Temp_UsElectionData = JSON.parse(JSON.stringify(window.UsElectionData))
  // console.log('resetUsData', window.Temp_UsElectionData)
  // console.log('UsElectionData', window.UsElectionData)

  calculateUsData()
}
function calculateUsData() {
  let solidD = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'solid-D'
  ).reduce((sum, state) => sum + state.Votes, 0)
  let leanD = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'lean-D'
  ).reduce((sum, state) => sum + state.Votes, 0)
  let userD = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'user-sel-D'
  ).reduce((sum, state) => sum + state.Votes, 0)
  let solidR = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'solid-R'
  ).reduce((sum, state) => sum + state.Votes, 0)
  let leanR = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'lean-R'
  ).reduce((sum, state) => sum + state.Votes, 0)
  let userR = window.Temp_UsElectionData.filter(
    (state) => state.Ranking === 'user-sel-R'
  ).reduce((sum, state) => sum + state.Votes, 0)

  document.getElementById('total-votes-D').textContent =
    parseInt(solidD) + parseInt(leanD) + parseInt(userD)
  document.getElementById('total-votes-R').textContent =
    parseInt(solidR) + parseInt(leanR) + parseInt(userR)

  // console.log('solidD', solidD)
  // console.log('leanD', leanD)
  // console.log('userD', userD)
  // console.log('solidR', solidR)
  // console.log('leanR', leanR)
  // console.log('userR', userR)
  document.documentElement.style.setProperty('--solid-D', solidD)
  document.documentElement.style.setProperty('--lean-D', leanD)
  document.documentElement.style.setProperty('--user-sel-D', userD)
  document.documentElement.style.setProperty('--solid-R', solidR)
  document.documentElement.style.setProperty('--lean-R', leanR)
  document.documentElement.style.setProperty('--user-sel-R', userR)
  document.querySelectorAll('.single-state').forEach((element) => {
    const stateCode = element.getAttribute('data-state')
    const stateData = window.Temp_UsElectionData.find(
      (state) => state.Code === stateCode
    )
    element.classList.remove(
      'fill-solid-D',
      'fill-solid-R',
      'fill-lean-D',
      'fill-lean-R',
      'fill-user-sel-D',
      'fill-user-sel-R',
      'fill-swing'
    )
    if (stateData) {
      element.classList.add(
        `fill-${
          stateData.Ranking.charAt(0).toLowerCase() + stateData.Ranking.slice(1)
        }`
      )
    }
  })
}
